module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAfCAYAAABplKSyAAABUklEQVRYhe2VQUrDQBSGv6miEKy38BBd9A5d1DSbXEUUcSEU200Ood30DD1Dd72FdlFT9XfhBELI0GSYimB+GIZ5M/97H5nMDJKw7UHSm+1p2IJ4jCSsPoATIAfOaaYgnjKESgtNw4RBPL2GxqOqgyj0pyBmlXh1HEpx7VjSVPWaNTjzZR1aO3bUiZG0k6QsyzQcDpVlWTG5CwyxdtRZG9mLYjAYsN/viaKI1WpVfK5DZ7/NPfEOnNXUyXt2kjRNiaKIJEnKppDaOOpskPTk2Kt54O24dtSZFAvmHgBtIZA0qQKo8oD977fj1NeopYnNJXxtoXcBeiU2I7345PLaDi3NGFjUTE0agATbjltH/MYnmS/EVcv4USA2LeNHgbhzxO9/DcKMtAAS+vz8Wn0AEjPSs1e+7rKy6iAKdRCFyhCfts9b+IN4yhCPwBaYtkgYxPMNyWCBgvsy8dAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y29.png
// module id = OwxF
// module chunks = 1